import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const mobileInstructionStatusTypeOptions = [
  'Retrieved',
  'Executed',
  'Failed',
] as const;

export const mobileInstructionStatusTypeSchema = createEnumSchemaPreprocessor(
  z.enum(mobileInstructionStatusTypeOptions),
  mobileInstructionStatusTypeOptions
);

export type MobileInstructionStatusType = z.infer<
  typeof mobileInstructionStatusTypeSchema
>;
